export default "__VITE_ASSET__0jyKaO9C__"